module.exports = __webpack_public_path__ + "static/media/circle-aprendiz.d5a66273.svg";